import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ButtonConfig } from "../../../design-system/button/button.modal";
import { ButtonComponent } from "../../../design-system/button/button.component";

@Component({
    selector: 'dual-button-functions',
    templateUrl: './dual-button-functions.component.html',
    standalone: true,
    imports: [ButtonComponent, TranslateModule],
})
export class DualButtonFunctionsComponent implements ICellRendererAngularComp {
    viewdetailaction: string = "ViewDetailAction";
    actionButtons: any[] = [];
    params: ICellRendererParams;
    data: any = {};
    buttontext: string = '';
    action1: string = '';
    action2: string = '';
    constructor(private translate: TranslateService) { }

    buttonConfig1: ButtonConfig = {size: 'sm'};
    buttonConfig2: ButtonConfig = {size: 'sm'};

    onUserAction(action) {
        this.params.data.userAction = action;
        this.params.node.setData(this.params.data);
        this.params.eGridCell.click();
    }

    initilize(params: ICellRendererParams) {
        if (params && params.data) {
            this.params = params;
            let data = params.colDef.headerComponentParams;
            this.action1 = data.action1;
            this.action2 = data.action2;
            this.buttonConfig1 = { ...this.buttonConfig1,
                id: '',
                label: data.buttonText1,
                color: data.color,
            }
            this.buttonConfig2 = { ...this.buttonConfig2,
                id: '',
                label: data.buttonText2,
                color: data.color,
            }
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}